import React from "react"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./QuotesComponent.module.scss"

const QuotesComponent = props => {
  const { data, isFullScreen } = props

  //card code
  const QuoteCard = ({ quoteData }) => {
    return (
      <div
        className={`bg-white text-[#2c3d50] p-[20px] max-w-[260px] rounded-2xl lg:max-h-[380px] lg:min-h-[380px] shadow-md ${styles.quoteCardWrapper}`}
      >
        <img
          loading="lazy"
          src={quoteData.image.file.url}
          alt="edc user"
          className="w-[80px] mx-auto rounded-full h-[80px] object-cover mb-[4px]"
        />
        <RenderRichContent content={quoteData.text} />
        <img
          loading="lazy"
          src={quoteData.doubleImage[0].file.url}
          alt="company logo"
          className="pt-[15px] mb-0 h-[50px] w-full object-contain"
        />
      </div>
    )
  }
  //card code end

  return (
    <div
      className={`bg-edc-dark-blue text-white py-[50px] px-2 text-center font-bold text-[34px] ${isFullScreen ? "w-full h-full" : "max-w-[100%] mx-auto rounded-2xl"} `}
    >
      <div className={`${styles.sliderIntroHeader}`}>
        <RenderRichContent content={data.sliderIntro} />
      </div>
      <div className="flex justify-between max-w-[840px] mx-auto flex-col md:flex-row items-center gap-5">
        {data.sliderItems.map((quote, index) => {
          if (index > 2) return null
          return <QuoteCard key={index} quoteData={quote} />
        })}
      </div>
    </div>
  )
}

export default QuotesComponent
